<template>
  <EmptyListingBlock title="Finished">
    <div>
      <slot />
    </div>
    <img src="@/assets.app/images/finished-demo.gif" />
  </EmptyListingBlock>
</template>

<script setup lang="ts">
import EmptyListingBlock from '@/app/components/listing/EmptyListingBlock.vue'
</script>
